// Libraries
var React = require('react');

// Components
var OptaWidget = require('../OptaWidget/OptaWidget');

// Styles
require('./MatchChalkboard.scss');

class MatchChalkboardModule extends React.Component {
    
	render() {
        return (
            <div className="MatchChalkboard">
                <h2>Chalkboard</h2>
                <OptaWidget language={this.props.data.language} timezone={this.props.data.timezone} subscriptionId={this.props.data.subscriptionId} properties={this.props.data.properties}/>
            </div>)
    }
}
    
module.exports = MatchChalkboardModule;


// WEBPACK FOOTER //
// ./src/components/MDC/MatchChalkboard/MatchChalkboardModule.js